import { render, staticRenderFns } from "./jzDate.vue?vue&type=template&id=30d1164b&scoped=true"
import script from "./jzDate.vue?vue&type=script&lang=js"
export * from "./jzDate.vue?vue&type=script&lang=js"
import style0 from "./jzDate.vue?vue&type=style&index=0&id=30d1164b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d1164b",
  null
  
)

export default component.exports